import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class Soal extends BaseEntity {

    @serialize
    @deserialize
    public bank_soal_id: number = 0;

    @serialize
    @deserialize
    public aspek_bank_soal_id: number = 0;

    @serialize
    @deserialize
    public nomor: number = 0;

    @serialize
    @deserialize
    public soal: string = "";

    @serialize
    @deserialize
    public pilihan_a: string = "";

    @serialize
    @deserialize
    public pilihan_b: string = "";

    @serialize
    @deserialize
    public pilihan_c: string = "";

    @serialize
    @deserialize
    public pilihan_d: string = "";

    @serialize
    @deserialize
    public pilihan_e: string = "";

    @serialize
    @deserialize
    public jawaban: string = "";

    @serialize
    @deserialize
    public kunci_jawaban: string = "";

    @serialize
    @deserialize
    public aspek: string = "";

}